import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { PrivateEditorGroup } from "./admin/pages/inc/PrivateRoute";
import { PrivateGroup } from "./admin/pages/inc/PrivateRoute";
import { PrivateAdministrateur } from "./admin/pages/inc/PrivateRoute";
import { PrivateActif } from "./admin/pages/inc/PrivateRoute";
import PrivateEditor from "./admin/pages/inc/PrivateRoute";
import LoadingPage from "./admin/pages/inc/LoadingPage";

import { store } from "./global";
import { Provider } from "react-redux";

import "./admin/assets/css/back-style.css";
import "./admin/assets/vendor/bootstrap/css/bootstrap.min.css";
import "./admin/assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./admin/assets/vendor/boxicons/css/boxicons.min.css";
import "./admin/assets/vendor/simple-datatables/style.css";
import "./admin/assets/css/table-responsive.css";
import "./admin/assets/vendor/remixicon/remixicon.css";
import NouveauNewsletter from "./admin/pages/newsletter/AddNewsletter";
import ListNewsletter from "./admin/pages/newsletter/ListNewsletter";
import UpdateNewsletter from "./admin/pages/newsletter/UpdateNewsletter";
import Newsletter from "./project/components/newsletter/Newsletter";
import EventPage from "./project/components/events/EventPage";

// Project
const Home = lazy(() => import("./project/pages/Home"));
const Pole = lazy(() => import("./project/pages/Pole"));
const DetailActualite = lazy(() => import("./project/pages/DetailActualite"));
const TranscriptionPodcast = lazy(
  () => import("./project/pages/TranscriptionPodcast"),
);
const Search = lazy(() => import("./project/pages/Search"));
const AxianEnergy = lazy(() => import("./project/pages/Energy"));

// Admin
const ListeCommunique = lazy(
  () => import("./admin/pages/communique-de-presse/ListeCommunique"),
);
const ListeEvenement = lazy(
  () => import("./admin/pages/evenement/ListeEvenement"),
);
const ListePodcast = lazy(() => import("./admin/pages/podcast/ListePodcast"));
// const ListeMedia = lazy(() => import('./pages/media/ListeMedia'));
const ListeUtilisateur = lazy(
  () => import("./admin/pages/utilisateur/ListeUtilisateur"),
);
const ListAbonnee = lazy(() => import("./admin/pages/abonnee/ListAbonnee"));
const Automatisations = lazy(() => import("./admin/pages/automatisation/Automatisations"));
const GridMedia = lazy(() => import("./admin/pages/media/GridMedia"));
const ListeCategorie = lazy(
  () => import("./admin/pages/categorie/ListeCategorie"),
);
const ListeCategorieMedia = lazy(
  () => import("./admin/pages/categorie-media/ListeCategorieMedia"),
);

const Login = lazy(() => import("./admin/pages/Login"));

const NouvelleTraduction = lazy(
  () => import("./admin/pages/communique-de-presse/NouvelleTraduction"),
);
const NouveauCommunique = lazy(
  () => import("./admin/pages/communique-de-presse/NouveauCommunique"),
);
const NouveauEvenement = lazy(
  () => import("./admin/pages/evenement/NouveauEvenement"),
);
const NouveauPodcast = lazy(
  () => import("./admin/pages/podcast/NouveauPodcast"),
);
const NouvelUtilisateur = lazy(
  () => import("./admin/pages/utilisateur/NouvelUtilisateur"),
);
const NouveauMedia = lazy(() => import("./admin/pages/media/NouveauMedia"));
const NouveauAbonnee = lazy(
  () => import("./admin/pages/abonnee/NouveauAbonnee"),
);
const NouveauTheme = lazy(
  () => import("./admin/pages/categorie/NouveauCategorie"),
);
const NouveauCategorieMedia = lazy(
  () => import("./admin/pages/categorie-media/NouveauCategorieMedia"),
);

const ModificationUtilisateur = lazy(
  () => import("./admin/pages/utilisateur/ModificationUtilisateur"),
);
const ModificationCommunique = lazy(
  () => import("./admin/pages/communique-de-presse/ModificationCommunique"),
);
const ModificationEvenement = lazy(
  () => import("./admin/pages/evenement/ModificationEvenement"),
);
const ModificationPodcast = lazy(
  () => import("./admin/pages/podcast/ModificationPodcast"),
);
// const ModificationMedia = lazy(() => import('./pages/media/ModificationMedia'));
const ModificationAbonnee = lazy(
  () => import("./admin/pages/abonnee/ModificationAbonnee"),
);
const GridModificationAbonnee = lazy(
  () => import("./admin/pages/media/NewModifyMedia"),
);
const ModificationTheme = lazy(
  () => import("./admin/pages/categorie/ModificationCategorie"),
);
const ModificationCategorieMedia = lazy(
  () => import("./admin/pages/categorie-media/ModificationCategorieMedia"),
);

const FicheCommunique = lazy(
  () => import("./admin/pages/communique-de-presse/FicheCommunique"),
);
const FicheAbonnee = lazy(() => import("./admin/pages/abonnee/FicheAbonnee"));
const FicheNewsletter = lazy(
  () => import("./admin/pages/newsletter/FicheNewsletter"),
);
const FicheDocument = lazy(
  () => import("./admin/pages/document/FicheDocument"),
);
const FicheEvenement = lazy(
  () => import("./admin/pages/evenement/FicheEvenement"),
);
const FicheUtilisateur = lazy(
  () => import("./admin/pages/utilisateur/FicheUtilisateur"),
);
const FicheTheme = lazy(() => import("./admin/pages/categorie/FicheCategorie"));
const FicheCategorieMedia = lazy(
  () => import("./admin/pages/categorie-media/FicheCategorieMedia"),
);

const Dashboard = lazy(() => import("./admin/pages/dashboard/Dashboard"));

const NotFound = lazy(() => import("./admin/pages/inc/NotFound"));
const AccountActivated = lazy(
  () => import("./admin/pages/inc/AccountActivated"),
);
const AccountNonActivated = lazy(
  () => import("./admin/pages/inc/AccountNonActivated"),
);
const Profile = lazy(() => import("./admin/pages/inc/Profile"));
const GlogalSearch = lazy(() => import("./admin/pages/search/GlobalSearch"));
const FulltextSeach = lazy(() => import("./admin/pages/search/FulltextSearch"));
const History = lazy(() => import("./admin/pages/history/ListHistory"));

const Phototheque = lazy(() => import("./admin/pages/photo/ListPhoto"));
const NouveauPhoto = lazy(() => import("./admin/pages/photo/CreatePhoto"));
const ModificationPhoto = lazy(() => import("./admin/pages/photo/ApercuPhoto"));

// const Videotheque = lazy(() => import('./pages/video/ListVideo'));
const CoolVideo = lazy(() => import("./admin/pages/video/YoutubeVideo"));
const NouveauVideo = lazy(() => import("./admin/pages/video/NouvelVideo"));
const ModificationVideo = lazy(() => import("./admin/pages/video/ModifyVideo"));

const ListDocument = lazy(() => import("./admin/pages/document/ListDocument"));
const NouveauDocument = lazy(
  () => import("./admin/pages/document/CreateDocument"),
);
const ModificationDocument = lazy(
  () => import("./admin/pages/document/ApercuDocument"),
);

const NouveauContact = lazy(
  () => import("./admin/pages/contact/CreateContact"),
);
const ListContact = lazy(() => import("./admin/pages/contact/ListContact"));
const ModificationContact = lazy(
  () => import("./admin/pages/contact/ModificationContact"),
);
const FicheContact = lazy(() => import("./admin/pages/contact/FicheContact"));

const ListEntite = lazy(() => import("./admin/pages/entite/ListeEntite"));
const AddEntite = lazy(() => import("./admin/pages/entite/NouveauEntite"));
const ModificationEntite = lazy(
  () => import("./admin/pages/entite/ModificationEntite"),
);
const FicheEntite = lazy(() => import("./admin/pages/entite/FicheEntite"));

const root = ReactDOM.createRoot(document.getElementById("root"));

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <PrivateActif>
            <Dashboard />
          </PrivateActif>
        }
      />
      <Route
        path="/list-evenement"
        element={
          <PrivateGroup>
            {" "}
            <ListeEvenement />{" "}
          </PrivateGroup>
        }
      />
      <Route
        path="/list-communique"
        element={
          <PrivateActif>
            <ListeCommunique />
          </PrivateActif>
        }
      />
      <Route
        path="/list-podcast"
        element={
          <PrivateGroup>
            {" "}
            <ListePodcast />
          </PrivateGroup>
        }
      />
      <Route
        path="/list-media"
        element={
          <PrivateActif>
            <GridMedia />
          </PrivateActif>
        }
      />{" "}
      {/* A voir */}
      <Route
        path="/list-utilisateur"
        element={
          <PrivateAdministrateur>
            {" "}
            <ListeUtilisateur />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/list-theme"
        element={
          <PrivateAdministrateur>
            {" "}
            <ListeCategorie />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/list-entite"
        element={
          <PrivateAdministrateur>
            <ListEntite />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/list-categorie-media"
        element={
          <PrivateAdministrateur>
            {" "}
            <ListeCategorieMedia />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/list-abonnee"
        element={
          <PrivateAdministrateur>
            {" "}
            <ListAbonnee />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/grid-media"
        element={
          <PrivateActif>
            <GridMedia />
          </PrivateActif>
        }
      />{" "}
      {/* A voir */}
      <Route
        path="/add-communique"
        element={
          <PrivateEditor>
            {" "}
            <NouveauCommunique />{" "}
          </PrivateEditor>
        }
      />
      <Route
        path="/add-evenement"
        element={
          <PrivateEditorGroup>
            {" "}
            <NouveauEvenement />{" "}
          </PrivateEditorGroup>
        }
      />
      <Route
        path="/add-podcast"
        element={
          <PrivateEditorGroup>
            {" "}
            <NouveauPodcast />{" "}
          </PrivateEditorGroup>
        }
      />
      <Route
        path="/add-media"
        element={
          <PrivateEditorGroup>
            {" "}
            <NouveauMedia />{" "}
          </PrivateEditorGroup>
        }
      />
      <Route
        path="/add-utilisateur"
        element={
          <PrivateAdministrateur>
            {" "}
            <NouvelUtilisateur />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/add-theme"
        element={
          <PrivateAdministrateur>
            {" "}
            <NouveauTheme />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/add-entite"
        element={
          <PrivateAdministrateur>
            <AddEntite />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/add-categorie-media"
        element={
          <PrivateAdministrateur>
            {" "}
            <NouveauCategorieMedia />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/add-abonnee"
        element={
          <PrivateAdministrateur>
            {" "}
            <NouveauAbonnee />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/modify-utilisateur/:id"
        element={
          <PrivateAdministrateur>
            <ModificationUtilisateur />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/modify-theme/:id"
        element={
          <PrivateAdministrateur>
            <ModificationTheme />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/modify-entite/:id"
        element={
          <PrivateAdministrateur>
            <ModificationEntite />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/modify-categorie-media/:id"
        element={
          <PrivateAdministrateur>
            <ModificationCategorieMedia />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/modify-abonnee/:id"
        element={
          <PrivateAdministrateur>
            <ModificationAbonnee />{" "}
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/traduire-communique/:id"
        element={
          <PrivateEditor>
            <NouvelleTraduction />
          </PrivateEditor>
        }
      />
      <Route
        path="/modify-communique/:id"
        element={
          <PrivateEditor>
            {" "}
            <ModificationCommunique />{" "}
          </PrivateEditor>
        }
      />
      <Route
        path="/modify-evenement/:id"
        element={
          <PrivateEditorGroup>
            <ModificationEvenement />{" "}
          </PrivateEditorGroup>
        }
      />
      <Route
        path="/modify-podcast/:id"
        element={
          <PrivateEditorGroup>
            <ModificationPodcast />
          </PrivateEditorGroup>
        }
      />
      {/* <Route path="/modify-media/:id" element={<ModificationMedia />} /> A voir */}
      <Route
        path="/modify-media/:id"
        element={
          <PrivateActif>
            <GridModificationAbonnee />
          </PrivateActif>
        }
      />{" "}
      {/* A voir */}
      <Route
        path="/fiche-communique/:id"
        element={
          <PrivateActif>
            <FicheCommunique />
          </PrivateActif>
        }
      />
      <Route
        path="/fiche-evenement/:id"
        element={
          <PrivateGroup>
            <FicheEvenement />
          </PrivateGroup>
        }
      />
      <Route
        path="/fiche-utilisateur/:id"
        element={
          <PrivateAdministrateur>
            <FicheUtilisateur />
          </PrivateAdministrateur>
        }
      />
      {/* <Route path='/fiche-utilisateur/:id' element={<PrivateActif><FicheCommunique /></PrivateActif>} /> */}
      <Route
        path="/fiche-abonnee/:id"
        element={
          <PrivateAdministrateur>
            <FicheAbonnee />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/automatisations"
        element={
          <PrivateAdministrateur>
            <Automatisations />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/fiche-theme/:id"
        element={
          <PrivateAdministrateur>
            <FicheTheme />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/fiche-entite/:id"
        element={
          <PrivateAdministrateur>
            <FicheEntite />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/fiche-categorie-media/:id"
        element={
          <PrivateAdministrateur>
            <FicheCategorieMedia />
          </PrivateAdministrateur>
        }
      />
      <Route path="/activated" element={<AccountActivated />} />
      <Route path="/nonactivated" element={<AccountNonActivated />} />
      <Route
        path="/my-profile"
        element={
          <PrivateActif>
            <Profile />
          </PrivateActif>
        }
      />
      <Route
        path="/global-search"
        element={
          <PrivateActif>
            <GlogalSearch />
          </PrivateActif>
        }
      />
      <Route
        path="/history"
        element={
          <PrivateAdministrateur>
            <History />
          </PrivateAdministrateur>
        }
      />
      <Route
        path="/list-photo"
        element={
          <PrivateActif>
            <Phototheque />
          </PrivateActif>
        }
      />
      <Route
        path="/add-photo"
        element={
          <PrivateActif>
            <NouveauPhoto />
          </PrivateActif>
        }
      />
      <Route
        path="/modify-photo/:id"
        element={
          <PrivateActif>
            <ModificationPhoto />
          </PrivateActif>
        }
      />
      <Route
        path="/list-video"
        element={
          <PrivateActif>
            <CoolVideo />
          </PrivateActif>
        }
      />
      <Route
        path="/add-video"
        element={
          <PrivateActif>
            <NouveauVideo />
          </PrivateActif>
        }
      />
      <Route
        path="/modify-video/:id"
        element={
          <PrivateActif>
            <ModificationVideo />
          </PrivateActif>
        }
      />
      <Route
        path="/list-document"
        element={
          <PrivateActif>
            <ListDocument />
          </PrivateActif>
        }
      />
      <Route
        path="/add-document"
        element={
          <PrivateActif>
            <NouveauDocument />
          </PrivateActif>
        }
      />
      <Route
        path="/modify-document/:id"
        element={
          <PrivateActif>
            <ModificationDocument />
          </PrivateActif>
        }
      />
      <Route
        path="/add-contact"
        element={
          <PrivateActif>
            <NouveauContact />
          </PrivateActif>
        }
      />
      <Route
        path="/list-contact"
        element={
          <PrivateActif>
            <ListContact />
          </PrivateActif>
        }
      />
      <Route
        path="/modify-contact/:id"
        element={
          <PrivateActif>
            <ModificationContact />
          </PrivateActif>
        }
      />
      <Route
        path="/fiche-contact/:id"
        element={
          <PrivateActif>
            <FicheContact />
          </PrivateActif>
        }
      />
      <Route
        path="/fulltext-search"
        element={
          <PrivateActif>
            <FulltextSeach />
          </PrivateActif>
        }
      />
      <Route path="/add-NewsLetter" element={<NouveauNewsletter />} />
      <Route path="/list-NewsLetter" element={<ListNewsletter />} />
      <Route path="/update-NewsLetter/:id" element={<UpdateNewsletter />} />
      <Route path="/fiche-NewsLetter/:id" element={<PrivateActif><FicheNewsletter /></PrivateActif>} />
      <Route path="/fiche-document/:id" element={<PrivateActif><FicheDocument /></PrivateActif>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

root.render(
  <Provider store={store}>
    <BrowserRouter scrollRestoration="manual">
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pole" element={<Pole />} />
          <Route path="/actualite/:id" element={<DetailActualite />} />
          <Route path="/podcast/:id" element={<TranscriptionPodcast />} />
          <Route path="/search" element={<Search />} />
          <Route path="/axian-energy" element={<AxianEnergy />} />
          <Route path="/event-page" element={<EventPage />} />
          <Route path="/newsletter/:id" element={<Newsletter />} />

          <Route
            path={process.env.REACT_APP_ADMIN_URL + "/*"}
            element={<AdminRoutes />}
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </Provider>,
);

reportWebVitals();
